export default __webpack_public_path__ + "media/images/mailer/icon_file_download-338b3e3ac7e80add5a16d399b9e8d05c.png";